import { action, computed, makeObservable, observable } from 'mobx';
import Channel from '../models/channel';
import * as utils from '../../helpers/utils';
import processIncomingData from '../processIncomingData';

class ChannelStore {
  constructor(rootStore) {
    makeObservable(this);
    this.rootStore = rootStore;
  }

  @observable channels = [];

  sortChannelsByLastMessage = (a, b) => {
    let sortResult = 0;
    const lastMessageForFirstChannel = this.rootStore.messageStore.computedGetLastMessageForChannel(
      a
    );
    const lastMessageForSecondChannel = this.rootStore.messageStore.computedGetLastMessageForChannel(
      b
    );

    if (lastMessageForFirstChannel && !lastMessageForSecondChannel) {
      sortResult = -1;
    } else if (!lastMessageForFirstChannel && lastMessageForSecondChannel) {
      sortResult = 1;
    } else if (lastMessageForFirstChannel && lastMessageForSecondChannel) {
      sortResult =
        new Date(lastMessageForSecondChannel.Timestamp) -
        new Date(lastMessageForFirstChannel.Timestamp);
    }

    return sortResult;
  };

  checkIsChannelUnread = (channel) => {
    const channelLastMessage = this.rootStore.messageStore.computedGetLastMessageForChannel(
      channel
    );

    if (!channelLastMessage) {
      return false;
    }

    const notSeenByShopcontact = !channelLastMessage.SeenBy.some(
      (c) => c.ContactType.TypeId === utils.ContactTypeEnum.Internal.TypeId
    );

    const isAllowedMessageType =
      channelLastMessage.MessageType &&
      channelLastMessage.MessageType.TypeId !== utils.MessageTypeEnum.AutoReply.TypeId &&
      channelLastMessage.MessageType.TypeId !== utils.MessageTypeEnum.System.TypeId;

    return notSeenByShopcontact && isAllowedMessageType && !channelLastMessage.IsDeleted;
  };

  @computed get getChannels() {
    const settings = this.rootStore.settingsStore.getLoggedUserSettings;

    const channelsToGrab = this.channels
      .filter((f) => {
        let hasChannelType = this.rootStore.commonStore.channelTypeIdsToSearch.some(
          (s) => s === f.ChannelType.TypeId
        );

        if (hasChannelType && f.ChannelType.TypeId === utils.ChannelTypeEnum.WebChat.TypeId) {
          const webchatIsActiveAndFilteringIsDisabled =
            !this.rootStore.commonStore.showActiveWebChatChannels &&
            f.ChannelStateType?.TypeId === utils.ChannelStateTypeEnum.Active.TypeId;
          const webchatIsClosedAndFilteringIsDisabled =
            !this.rootStore.commonStore.showClosedWebChatChannels &&
            f.ChannelStateType?.TypeId === utils.ChannelStateTypeEnum.Closed.TypeId;

          if (webchatIsActiveAndFilteringIsDisabled || webchatIsClosedAndFilteringIsDisabled) {
            hasChannelType = false;
          }
        }

        let isChannelUnread;

        if (this.rootStore.commonStore.showUnreadChannelFilter) {
          isChannelUnread = this.checkIsChannelUnread(f);
        }

        return (
          f.ChannelType &&
          hasChannelType &&
          f.CustomerPhoneNumber &&
          f.LastMessage &&
          !settings.HiddenChannels.includes(f._id) &&
          !f.IsDeleted &&
          (this.rootStore.commonStore.showUnreadChannelFilter ? isChannelUnread : true)
        );
      })
      .sort(this.sortChannelsByLastMessage);

    if (settings?.SelectedChannel?.LastMessage === null) {
      channelsToGrab.unshift(settings.SelectedChannel);
    }

    return channelsToGrab;
  }

  @action UpsertAndGet(incObj) {
    return processIncomingData(incObj, this.rootStore, this.channels, Channel);
  }
}

export default ChannelStore;
